import { render, staticRenderFns } from "./incident_tabs.vue?vue&type=template&id=694288a2"
import script from "./incident_tabs.vue?vue&type=script&lang=js"
export * from "./incident_tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports